import TRANSLATION_ACCESSIBILITY_SV from './accessibility/translation';
import TRANSLATION_BOOKING_SV from './booking/translation';
import TRANSLATION_EVENTS_SV from './events/translation';
import TRANSLATION_EXPERIENCES_SV from './experiences/translation';
import TRANSLATION_FORM_SV from './form/translation';
import TRANSLATION_LANDING_PAGES_SV from './landingPages/translation';
import TRANSLATION_RESERVE_SV from './reserve/translation';
import TRANSLATION_SIGNIN_SV from './signin/translation';
import TRANSLATION_DATES_SV from './weekdays/translation';

export default {
  ...TRANSLATION_ACCESSIBILITY_SV,
  ...TRANSLATION_BOOKING_SV,
  ...TRANSLATION_DATES_SV,
  ...TRANSLATION_EVENTS_SV,
  ...TRANSLATION_EXPERIENCES_SV,
  ...TRANSLATION_FORM_SV,
  ...TRANSLATION_LANDING_PAGES_SV,
  ...TRANSLATION_RESERVE_SV,
  ...TRANSLATION_SIGNIN_SV,
};
